import React from 'react';
import {
  DialogContent,
  TextField,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import { DialogBox } from 'components';
import { strings } from 'i18n/Strings';
import Buttons from 'components/elements/Buttons';

interface ContributionDialogProps {
  open: boolean;
  onClose: () => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
  handleSearch: (value: string) => void;
  adminContributionUploadError: string;
  orgName: string;
  loading: boolean;
  handleProceed: () => void;
}

const ContributionDialog = (props: ContributionDialogProps): JSX.Element => {
  const {
    open,
    onClose,
    searchValue,
    setSearchValue,
    handleSearch,
    adminContributionUploadError,
    orgName,
    loading,
    handleProceed,
  } = props;

  return (
    <DialogBox
      open={open}
      onClose={onClose}
      title={strings.displayText.organizationIdUniqueId}
      className={''}
    >
      <DialogContent style={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          label={strings.displayText.enterOrganizationIdUniqueId}
          variant="outlined"
          value={searchValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSearchValue(e.target.value);
          }}
          style={{ width: '400px' }}
        />
        <Buttons
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
            void handleSearch(searchValue.trim());
          }}
          color="primary"
          style={{ marginLeft: '40px' }}
          disabled={searchValue === '' || loading}
          endIcon={loading ? <CircularProgress size={15} /> : null}
        >
          {strings.displayText.search}
        </Buttons>
      </DialogContent>
      {orgName && (
        <>
          <span style={{ marginLeft: '14px' }}>
            {strings.displayText.contributionConfirmation} {orgName} ?
          </span>
          <DialogActions>
            <Buttons onClick={onClose}>Cancel</Buttons>
            <Buttons onClick={handleProceed} autoFocus>
              Proceed
            </Buttons>
          </DialogActions>
        </>
      )}
      <span style={{ color: 'red', marginLeft: '14px' }}>
        {adminContributionUploadError}
      </span>
    </DialogBox>
  );
};

export default ContributionDialog;
